import React from 'react'
import LandlordHeader from '../../LandlordHeader'
import ActionCard from '../actionCard'
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux'
import { useParams } from 'react-router'
import { type RootState } from '../../../../store/store'
import _ from 'lodash'
import { updateOfferByMagic } from '../../../../store/actionsCreators/offerActions/magicOfferActions'
import { showFileInputAlert, showInputAlert, swalConfirm, swalError, swalSuccess } from '../../../../functions/swalOptions'
import { useNavigate } from 'react-router-dom'
import { setUnitSold } from '../../../../store/actionsCreators/unitsActions'
import confirmAction from '../../../../functions/swals/confirmAction'
import { setWhereAfterToGo } from '../../../../store/slices/modalSlice'
import { downloadPaySlip } from './uploadOfferPaySlip'
import { getOfferTypeName } from '../../../../functions/agent/offers/getOfferTypeName'
import { addOfferSaleContractDocuments } from '../../../../store/actionsCreators/offerActions/addOffer/sell/addOfferSaleContractDocuments'
import { updateOfferDetailsFromAgent } from '../../../../store/actionsCreators/offerActions/updateOfferDetailsFromAgent'
import { getDataUser } from '../../../../functions/agent/agentModuleComponent/getDataUser'
import { sendCustomNotification } from '../../../../functions/shared/notifications/sendCustomNotification'

import { sendNotification } from '../../../../functions/shared/notifications/sendNotification'
import { getCurrentDubaiDate } from '../../../../functions/agent/date/getCurrentDubaiDate'
import { toUTCWithOffset } from '../../../../functions/agent/date/toUTCWithOffset'

const OffersActions = (): JSX.Element => {
    const dispatch = useAppDispatch()
    const { unitID, offerID } = useParams()
    const offers = useAppSelector((state: RootState) => state.offers.offers)
    const units = useAppSelector((state: RootState) => state.units.units)
    const offer = _.find(offers, (offer) => offer.id === Number(offerID))
    const unit = _.find(units, (unit) => unit.id === Number(unitID))
    const status = offer?.attributes?.Statuses[offer?.attributes?.Statuses?.length - 1]
    const marketingUse = unit?.attributes?.Marketing?.Use
    const navigate = useNavigate()
    const isSale = getOfferTypeName(offer)?.includes('sale')

    return <>
        <LandlordHeader active={'Offer actions'} />
        <div className={'d-flex flex-column gap-4 p-4  mt-14'}>
            {_.includes(['Negotiated by agent', "Negotiation confirmed by agent"], status) &&
                <ActionCard
                    title={'Confirm agents\'s offer' + (status === 'Negotiated by agent' ? ' - Negotiated' : ' - consent')}
                    description={'Confirm the offer\'s price'}
                    onClick={() => {
                        confirmAction({
                            callback: async () => {
                                const { textNotification, textNavigate, isSuccessful } = await dispatch(updateOfferByMagic(Number(offerID), { Statuses: ['Confirmed'] }, 'Offer price has been confirmed', 'user-offer-confirmed', 'ATTENTION price on offer has been confirmed'))
                                if (isSuccessful) {
                                    const swalResult = await swalSuccess('Offer price has been confirmed')
                                    if (swalResult.isConfirmed) {
                                        navigate(textNavigate);
                                    }
                                } else {
                                    void swalError(textNotification);
                                }
                                dispatch(setWhereAfterToGo('/landlord/schedule'))
                            }
                        })
                    }}
                    icon={'check_circle'}
                />
            }
            {(status === 'In-process' || status === 'Rejected') &&
                <ActionCard
                    title={'Approve'}
                    description={'Check offer - Approve offer - and inform landlord'}
                    onClick={() => {
                        confirmAction({
                            callback: async () => {
                                const { textNotification, textNavigate, isSuccessful } = await dispatch(updateOfferByMagic(Number(offerID), { Statuses: ['Approved'] }, 'Offer has been approved', 'user-offer-approved', 'Great, offer has been approved', false, true))
                                if (isSuccessful) {
                                    const swalResult = await swalSuccess('Offer has been approved')
                                    if (swalResult.isConfirmed) {
                                        navigate(textNavigate);
                                    }
                                } else {
                                    void swalError(textNotification);
                                }
                                dispatch(setWhereAfterToGo('/landlord/schedule'))
                            }
                        })
                    }}
                    icon={'check_circle'}
                />
            }
            {_.includes(['Negotiated by landlord', 'Negotiated by BSO', 'Negotiated by agent', "Approved"], status) && // Comfirmed , 
                <>
                    <ActionCard
                        title={'Negotiate'}
                        description={'Negotiate on offer'}
                        onClick={() => {
                            navigate(`/landlord/modal/negotiate_offer_modal/${unitID ?? '-'}/${offerID ?? '-'}`)
                            dispatch(setWhereAfterToGo('/landlord/schedule'))
                        }}
                        icon={'monetization_on'}
                    />
                    <ActionCard
                        title={'Reject'}
                        description={'Reject offer'}
                        onClick={() => {
                            navigate(`/landlord/modal/reject_offer_modal/${unitID ?? '-'}/${offerID ?? '-'}`)
                        }}
                        icon={'cancel'}
                    />
                </>
            }
            {status === 'In-process' &&
                <ActionCard
                    title={'Require resubmit'}
                    description={'Require agent to resubmit offer'}
                    onClick={() => {
                        navigate(`/landlord/modal/require_resubmit_offer_modal/${unitID ?? '-'}/${offerID ?? '-'}`)
                        dispatch(setWhereAfterToGo('/landlord/schedule'))
                    }}
                    icon={'cancel'}
                />
            }
            {status === "Approved" &&
                <ActionCard
                    title={'Confirm from landlord - Go to next steps'}
                    description={''}
                    onClick={() => {
                        confirmAction({
                            callback: async () => {
                                const { textNotification, textNavigate, isSuccessful } = await dispatch(updateOfferByMagic(Number(offerID), { Statuses: ['Confirmed'] }, 'Offer price has been confirmed', 'user-offer-confirmed', 'ATTENTION price on offer has been confirmed'))
                                if (isSuccessful) {
                                    const swalResult = await swalSuccess('Offer price has been confirmed')
                                    if (swalResult.isConfirmed) {
                                        navigate(textNavigate);
                                    }
                                } else {
                                    void swalError(textNotification);
                                }
                                dispatch(setWhereAfterToGo('/landlord/schedule'))
                            }
                        })
                    }}
                    icon={'check_circle'}
                />
            }
            {status === "Slip approved" &&
                !isSale &&
                <ActionCard
                    title={'Confirm booking form sending'}
                    description={'Confirm that booking form is sent to client'}
                    onClick={() => {
                        void (async () => {
                            const response = await swalConfirm('Booking form', 'Send a booking form to client')
                            if (response.isConfirmed) {
                                const { textNotification, textNavigate, isSuccessful } = await dispatch(updateOfferByMagic(Number(offerID), { Statuses: ['Waiting booking form sign'] }, 'Booking form is send', 'user-offer-booking-form', 'Booking form is sent', false, false, true))
                                if (isSuccessful) {
                                    const swalResult = await swalSuccess('Booking form is send')
                                    if (swalResult.isConfirmed) {
                                        navigate(textNavigate);
                                    }
                                } else {
                                    await swalError(textNotification);
                                }
                                dispatch(setWhereAfterToGo('/landlord/schedule'))
                            }
                        })()
                    }}
                    icon={'description'}
                />
            }
            {status === 'Waiting for slip approval' &&
                <ActionCard
                    title={'Download check slip'}
                    description={'Download and check the deposit pay slip'}
                    onClick={() => {
                        downloadPaySlip(Number(offerID))
                        dispatch(setWhereAfterToGo('/landlord/schedule'))
                    }}
                    icon={'description'}
                />
            }
            {status === 'Waiting for slip approval' &&
                <ActionCard
                    title={isSale ? "Check cheque 10% -  Inform landlord - Send to Landlord" : 'Approve pay slip'}
                    description={isSale ? 'Check and approve the cheque deposit 10%' : 'Check and approve the deposit pay slip'}
                    onClick={() => {
                        void (async () => {
                            const { textNotification, textNavigate, isSuccessful } = await dispatch(updateOfferByMagic(Number(offerID), { Statuses: ['Slip approved'] }, 'Slip is successfully approved', 'user-offer-deposit-approved', 'ATTENTION deposit on offer has been approved', false, true))
                            if (isSuccessful) {
                                const swalResult = await swalSuccess('Slip has been successfully approved')
                                if (swalResult.isConfirmed) {
                                    navigate(textNavigate);
                                }
                            } else {
                                await swalError(textNotification);
                            }
                            dispatch(setWhereAfterToGo('/landlord/schedule'))
                        })()
                    }}
                    icon={'description'}
                />
            }
            {status === 'Waiting for slip approval' &&
                <ActionCard
                    title={isSale ? 'Reject the cheque deposit 10%' : 'Reject pay slip'}
                    description={isSale ? "Check and reject the cheque deposit 10%" : 'Check and reject the deposit pay slip'}
                    onClick={() => {
                        void (async () => {
                            const result = await showInputAlert('Reject pay slip - Write the reason for rejecting the deposit pay slip');
                            if (result.isConfirmed) {
                                const { input1 } = result.value;
                                const { textNotification, textNavigate, isSuccessful } = await dispatch(updateOfferByMagic(Number(offerID), { Statuses: ['Slip rejected'], RejectReason: input1 }, 'Slip has been successfully rejected', 'user-offer-deposit-rejected', 'ATTENTION deposit on offer has been rejected'))
                                if (isSuccessful) {
                                    const swalResult = await swalSuccess('Slip has been successfully rejected');
                                    if (swalResult.isConfirmed) {
                                        navigate(textNavigate);
                                    }
                                } else {
                                    const swalResult = await swalError(textNotification);
                                    if (swalResult.isConfirmed) {
                                        navigate(-1);
                                    }
                                }
                                dispatch(setWhereAfterToGo('/landlord/schedule'))
                            }
                        })()
                    }}
                    icon={'description'}
                />
            }

            {status === 'Waiting draft contract send' &&
                <ActionCard
                    title={'Upload draft contract file'}
                    description={'Upload draft contract file to Agent'}
                    onClick={() => {
                        void (async () => {
                            const result = await showFileInputAlert('Upload draft contract file to Agent');
                            if (result.isConfirmed) {
                                const file = result.value;
                                const { textNotification, textNavigate, isSuccessful } = await dispatch(addOfferSaleContractDocuments({ offerID: Number(offerID), file, status: 'Waiting draft contract approve', categoryDoc: "Draft Contract" }));
                                if (isSuccessful) {
                                    const swalResult = await swalSuccess(textNotification);
                                    if (swalResult.isConfirmed) {
                                        navigate(textNavigate);
                                    }
                                } else {
                                    const swalResult = await swalError(textNotification);
                                    if (swalResult.isConfirmed) {
                                        navigate(-1);
                                    }
                                }
                                dispatch(setWhereAfterToGo('/landlord/schedule'))
                            }
                        })();
                    }}
                    icon={'description'}
                />
            }



            {status === 'Waiting booking form sign' &&
                <ActionCard
                    title={'Check booking form sign'}
                    description={'Check booking form sign for offer'}
                    onClick={() => {
                        void (async () => {
                            const response = await swalConfirm('Booking form', 'Has the client confirmed the booking form?')
                            if (response.isConfirmed) {
                                navigate(`/landlord/modal/check_booking_form_modal/${unitID ?? '-'}/${offerID ?? '-'}`)
                            }
                            dispatch(setWhereAfterToGo('/landlord/schedule'))
                        })()
                    }}
                    icon={'menu'}
                />
            }

            {(status === 'F Form requested' || status === 'Manual contract requested') &&
                <ActionCard
                    title={status === 'F Form requested' ? 'Prepared - Sent F Form to client ' : 'Prepared - Sent manual contract to client'}
                    description={'The Agent will be know about it'}
                    onClick={() => {
                        confirmAction({
                            callback: async () => {
                                const { textNotification, isSuccessful } = await dispatch(updateOfferDetailsFromAgent(Number(offer?.id), { Statuses: [status === 'F Form requested' ? 'F Form sent' : 'Manual contract sent'], notifyInjection: 'Agent' }));
                                if (isSuccessful === true) {
                                    const { nameUser, nameAddress } = getDataUser(offer?.attributes?.User?.data?.id ?? 0, offer?.attributes?.Unit?.data?.id!)
                                    void sendCustomNotification(offer?.attributes?.User?.data?.id ?? 0,
                                        status === 'F Form requested' ? 'F Form sent' : 'Manual contract sent',
                                        `Dear ${nameUser}, on unit ${nameAddress}, '${status === 'F Form requested' ? 'F Form sent' : 'Manual contract sent'}'.`,
                                        `/agent/modalView/offer_modal/${String(offer?.attributes?.Unit?.data?.id)}/${offerID as string}/not?type=${String(offer?.attributes?.Type?.[0]?.__component ?? 'not').slice(6)}`)

                                    const swalResult = await swalSuccess('Draft contract has been approved');
                                    if (swalResult.isConfirmed) {
                                        navigate(`/landlord/modalView/magic_offer_modal/${String(offer?.attributes?.Unit?.data?.id)}/${offer?.id}/catalog?type=${String(offer?.attributes?.Type?.[0]?.__component ?? 'not').slice(6)}`)
                                    }
                                } else {
                                    const swalResult = await swalError(textNotification);
                                    if (swalResult.isConfirmed) {
                                        navigate(-1);
                                    }
                                }
                                dispatch(setWhereAfterToGo('/landlord/schedule'))
                            },
                            title: 'Are you sure the contract is sent to client?',
                            description: "",
                            confirmText: "Yes , main contract is sent"
                        })
                    }}
                    icon={'description'}
                />
            }
            {(status === 'F Form sent' || status === 'Manual contract sent') &&
                <ActionCard
                    title={status === 'F Form sent' ? 'Client has F Form signed  - send notice to agent' : 'Client has Manual contract signed  - send notice to agent'}
                    description={''}
                    onClick={() => {
                        confirmAction({
                            callback: async () => {
                                const { textNotification, isSuccessful } = await dispatch(updateOfferDetailsFromAgent(Number(offer?.id), { Statuses: [status === 'F Form sent' ? 'F Form signed' : 'Manual contract signed'], notifyInjection: 'Agent' }))
                                if (isSuccessful === true) {
                                    const { nameUser, nameAddress } = getDataUser(offer?.attributes?.User?.data?.id ?? 0, offer?.attributes?.Unit?.data?.id!)

                                    void sendCustomNotification(offer?.attributes?.User?.data?.id ?? 0,
                                        status === 'F Form sent' ? 'Client has F Form signed ' : 'Client has Manual contract signed ',
                                        `Dear ${nameUser}, on unit ${nameAddress}, offer has been updated'.`,
                                        `/agent/modalView/offer_modal/${String(offer?.attributes?.Unit?.data?.id)}/${offerID as string}/not?type=${String(offer?.attributes?.Type?.[0]?.__component ?? 'not').slice(6)}`)
                                    const swalResult = await swalSuccess('Draft contract has been approved');
                                    if (swalResult.isConfirmed) {
                                        navigate(`/landlord/modalView/magic_offer_modal/${String(offer?.attributes?.Unit?.data?.id)}/${offer?.id}/catalog?type=${String(offer?.attributes?.Type?.[0]?.__component ?? 'not').slice(6)}`)
                                    }
                                } else {
                                    const swalResult = await swalError(textNotification);
                                    if (swalResult.isConfirmed) {
                                        navigate(-1);
                                    }
                                }
                                dispatch(setWhereAfterToGo('/landlord/schedule'))
                            },
                            title: 'Are you sure the contract is signed  - send notice to agent with contract details?',
                            description: "Please confirm",
                            confirmText: "Document is signed "
                        })
                    }}
                    icon={'description'}
                />
            }

            {marketingUse === 'For sale'
                ? <>
                    {status && !['In-process', 'Sent to landlord', 'Negotiated by agent',
                        'Negotiated by yourself', 'Negotiated by BSO', 'Pending BSO admin confirmation',
                        'Waiting for slip approval', 'Completed'
                    ]?.includes(status) &&
                        <ActionCard
                            title={'Change offer dynamic status - add extra details'}
                            description={''}
                            onClick={() => {
                                void (async () => {
                                    const result = await showInputAlert('Change offer status', 'Please provide description here...');
                                    if (result.isConfirmed) {
                                        const { status, description, loadDocument } = result.value;
                                        const { textNotification, isSuccessful } = await dispatch(updateOfferDetailsFromAgent(Number(offer?.id), { Statuses: [status], StatusUpdateDescription: loadDocument ? "UPLOAD-URGENT " + description : description, notifyInjection: 'Agent' }))
                                        if (isSuccessful === true) {
                                            const swalResult = await swalSuccess('Status has been changed successfully');
                                            const { nameUser, nameAddress } = getDataUser(offer?.attributes?.User?.data?.id ?? 0, offer?.attributes?.Unit?.data?.id!)
                                            void sendCustomNotification(offer?.attributes?.User?.data?.id ?? 0,
                                                status,
                                                `Dear ${nameUser}, on unit ${nameAddress}, offer has been updated : '${description}'.`,
                                                `/agent/modalView/offer_modal/${String(offer?.attributes?.Unit?.data?.id)}/${offerID as string}/not?type=${String(offer?.attributes?.Type?.[0]?.__component ?? 'not').slice(6)}`)

                                            if (swalResult.isConfirmed) {
                                                navigate(`/landlord/modalView/magic_offer_modal/${String(offer?.attributes?.Unit?.data?.id)}/${offer?.id}/catalog?type=${String(offer?.attributes?.Type?.[0]?.__component ?? 'not').slice(6)}`)
                                            }
                                        } else {
                                            const swalResult = await swalError(textNotification);
                                            if (swalResult.isConfirmed) {
                                                navigate(-1);
                                            }
                                        }
                                        dispatch(setWhereAfterToGo('/landlord/schedule'))
                                    }
                                })();
                            }}
                            icon={'edit'}
                        />
                    }
                </>
                :
                <>
                </>
            }
            {status && !['In-process', 'Sent to landlord', 'Negotiated by agent', 'Negotiated by yourself', 'Negotiated by BSO', 'Pending BSO admin confirmation', 'Waiting for slip approval', 'Completed']?.includes(status) &&
                (
                    <ActionCard
                        title={'Complete offer'}
                        description={'The deal is done'}
                        onClick={() => {
                            confirmAction({
                                callback: async () => {
                                    const { textNotification, isSuccessful } = await dispatch(updateOfferDetailsFromAgent(Number(offer?.id), { Statuses: ['Completed'], StatusUpdateDescription: null, notifyInjection: 'Agent' }))
                                    if (isSuccessful === true) {
                                        const swalResult = await swalSuccess('Status has been changed successfully');
                                        const unitId = offer?.attributes?.Unit?.data?.id;
                                        const userId = offer?.attributes?.User?.data?.id;

                                        await sendNotification(toUTCWithOffset(getCurrentDubaiDate()), Number(userId), offer.id, 'user-offer-completed', 'Offer - ' + String(status))
                                        if (unitId != null && userId != null) {
                                            void dispatch(setUnitSold(unitId, false, userId));
                                        } else {
                                            void swalError('Unit ID or User ID is missing');
                                        }
                                        if (swalResult.isConfirmed) {
                                            navigate(`/landlord/modalView/magic_offer_modal/${String(offer?.attributes?.Unit?.data?.id)}/${offer?.id}/catalog?type=${String(offer?.attributes?.Type?.[0]?.__component ?? 'not').slice(6)}`)
                                        }
                                    } else {
                                        const swalResult = await swalError(textNotification);
                                        if (swalResult.isConfirmed) {
                                            navigate(-1);
                                        }
                                    }
                                }
                            })
                        }}
                        icon={'check_circle'}
                    />
                )
            }
            {status && !['Completed', 'Sent to landlord', 'Negotiated by agent', 'Negotiated by yourself', 'Negotiated by BSO', 'Pending BSO admin confirmation'].includes(status) &&
                <ActionCard
                    title={'Reject'}
                    description={'Reject offer'}
                    onClick={() => {
                        navigate(`/landlord/modal/reject_offer_modal/${unitID ?? '-'}/${offerID ?? '-'}`)
                    }}
                    icon={'cancel'}
                />
            }


        </div>
    </>
}

export default OffersActions
